<template>
  <div class="-social">
    <div class="-thumbnail-wrapper">
      <div v-if="!!src" class="-thumbnail" @click="previewVideoAsset">
        <wt-asset-overlay
          :dateFull="publicationDateFull"
          :show-play-icon="isVideo && !selected"
        >
          <span
            slot="append-right"
            class="-duration"
            v-if="isVideo && (selected || showDuration)"
          >
            <span v-if="selected">▶︎</span>
            <span v-else-if="!!duration && isInFavoritesTab">{{
              duration
            }}</span>
          </span>
        </wt-asset-overlay>
        <a href="#">
          <img :src="mixinSrc(src)" />
        </a>
        <slot name="checkmark"></slot>
      </div>
      <div v-else class="-post" @click="previewAsset">
        <div class="-inner">
          <div class="-post-text" dir="auto">{{ asset.metadata.caption }}</div>
          <div class="-social-icons-box -asset-overlay-social">
            <span class="-twitter-icon wticon wticon-twitter2"></span>
          </div>
        </div>
        <slot name="checkmark"></slot>
      </div>
      <footer class="-social">
        <div class="-asset-details">
          <div class="-date" :title="publicationDateFull">
            {{ publicationDate }}
          </div>
          <div class="-activity">
            <span v-if="favoriteCount" :title="favoriteTitle">
              <span class="wticon wticon-heart"></span>
              <span>{{ favoriteCount }}</span>
            </span>
            <span v-if="retweetCount" :title="retweetTitle">
              <span class="wticon wticon-retweet"></span>
              <span>{{ retweetCount }}</span>
            </span>
          </div>
        </div>
        <div class="-user-details">
          <img
            class="wt-asset-social-profile-image"
            :src="asset.metadata.socialUserProfileImageUrl"
          />
          <span class="-social-name">{{ asset.metadata.socialUserName }}</span>
          <span class="-social-screen-name"
            >@{{ asset.metadata.socialUserScreenName }}</span
          >
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetOverlay from 'components/assets/mixins/AssetOverlay.vue';
import Vue from 'vue';
import app from 'app';

export default Vue.extend({
  mixins: [AssetMixins],
  components: { 'wt-asset-overlay': AssetOverlay },

  props: {
    searchContextId: {
      type: String,
      required: true,
    },
  },

  computed: {
    isInFavoritesTab() {
      return this.searchContextId === app.PROVIDERS.FAVORITES.id;
    },

    type() {
      const type = this.asset.metadata.twitterPostType;
      return type || 'text';
    },

    isVideo() {
      return this.type === 'video';
    },

    isImage() {
      return this.type === 'photo';
    },

    src() {
      if (this.type === 'video') {
        return this.asset.metadata.posterUrl;
      }
      if (this.type === 'photo') {
        return this.asset.metadata.providerLowResAssetUrl;
      }

      return null;
    },

    favoriteTitle() {
      if (this.asset.metadata.socialFavoriteCount) {
        return (
          this.asset.metadata.socialFavoriteCount.toLocaleString() + ' Likes'
        );
      }
      return false;
    },

    retweetTitle() {
      if (this.asset.metadata.socialRetweetCount) {
        return (
          this.asset.metadata.socialRetweetCount.toLocaleString() + ' Retweets'
        );
      }
      return false;
    },

    retweetCount() {
      if (!this.asset.metadata.socialRetweetCount) {
        return 0;
      }
      return this.asset.metadata.socialRetweetCount.toFriendlyNumber(1);
    },

    favoriteCount() {
      if (!this.asset.metadata.socialFavoriteCount) {
        return 0;
      }
      return this.asset.metadata.socialFavoriteCount.toFriendlyNumber(1);
    },

    showDuration() {
      return !!this.duration;
    },

    duration() {
      if (!this.asset.metadata.duration) {
        return '';
      }
      return app.moment.utc(this.asset.metadata.duration * 1000).format('m:ss');
    },
  },
});
</script>
